import { defineComponent as _defineComponent } from 'vue'
import LocationMap from '@/components/LocationMap.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationView',
  setup(__props) {


return { __sfc: true,LocationMap }
}

})